import React, { useState, useContext, useEffect, useMemo } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import Tool_mealList from "../../Components/Tools/Tool_mealList";
import Tool_mealListShowOnly from '../../Components/Tools/Tool_mealListShowOnly';
import Tool_showExtraDataList from "../../Components/Tools/Tool_showExtraDataList";
import { Global } from '../../App';
import { FormattedMessage } from 'react-intl';
import qs from 'querystring';
import moment from 'moment';
import '../pages.scss';
// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';
// api
import {
  getShareOrderDetail,
  cancelShareOrderDetail
} from '../../Api/GetOrder';
import QRCode from "qrcode.react";
import cls from 'classnames';

import calcTotal from '../../Share/Tools/calcTotal'


function ShowOrderDetail(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    dineIn: [],
    takeout: [],
    isInit: false
  });
  const handlerErr = promise => {
    return promise
      .then(e => {
        return [null, e];
      })
      .catch(err => {
        return [err];
      });
  };
  // 檢查get參數
  const checkURL = useMemo(() => {
    const { search } = props.location;
    if (search !== '' && search !== undefined && search !== null) {
      const par = qs.parse(search.split('?')[1]);
      return par;
    } else {
      return '';
    }
  }, [props.location.search]);

  const hostname = useMemo(() => {
    return `${window.location.protocol}//${window.location.host}${window.env.BASENAME}`
  }, []);

  async function apiShareOrderDetail() {
    const { orderCode, langId, storeID, createAt } = checkURL;
    const [err, res] = await handlerErr(
      getShareOrderDetail(orderCode, langStringToCode(globalState.langType), Number(storeID), createAt)
    );
    if (err) {
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 414 }]
      });
      props.history.push('/error');
    } else {
      const { errCode, orderList } = res.data;
      console.log("orderList", orderList)
      orderList.forEach((order) => {
        order.isOpen = true;
      });
      if (errCode == 200) {
        setState(curr => ({
          ...orderList,
          dineIn: orderList[0].dineIn,
          takeout: orderList[0].takeout,
          isInit: true,
          orderList: orderList
        }));
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/error');
      }
    }
  }
  // call api
  useEffect(() => {
    apiShareOrderDetail();
    return () => {
      cancelShareOrderDetail('cancel');
    };
  }, [globalState.langType]);


  const $totalPrice = useMemo(() => {
    const { dineIn, takeout } = state;
    const takeoutTotals = calcTotal(takeout)
    const dineInTotals = calcTotal(dineIn)

    return {
      dineInTotalPrice: dineInTotals.total,
      dineInSpecPrice: dineInTotals.tasteTotal,
      takeoutInTotalPrice: takeoutTotals.total,
      takeoutInSpecPrice: takeoutTotals.tasteTotal
    };
  }, [state])

  const totalPrice = () => {
    return $totalPrice
  };

  const totalPriceList = (e) => {
    console.log("e:", e)
    const { dineIn, takeout } = e;
    const takeoutTotals = calcTotal(takeout)
    const dineInTotals = calcTotal(dineIn)

    return {
      dineInTotalPrice: dineInTotals.total,
      dineInSpecPrice: dineInTotals.tasteTotal,
      takeoutInTotalPrice: takeoutTotals.total,
      takeoutInSpecPrice: takeoutTotals.tasteTotal
    };
    // return $totalPrice
  };
  // 四捨五入至小數點第n位
  const formatNumber = (value, pos) => {
    const float = Math.pow(10, pos);
    return (Math.round(value * float) / float).toFixed(pos);
  };
  function checkIsOrderValid(alive, status, createAt) {
    const data = alive ? ((status === 1) && (Date.parse(createAt) - Date.parse(moment(new Date()).format('YYYY/MM/DD')) < 0) ? 2 : 1) : 0;
    switch (data) {
      case 0:
        return {
          txt: 'pages.showOrderDetail.orderValid.invalid',
          style: 'orderStateExpired'
        };
      case 1:
        return {
          txt: 'pages.showOrderDetail.orderValid.valid',
          style: ''
        };
      case 2:
        return {
          txt: 'pages.showOrderDetail.orderValid.expired',
          style: ''
        };
      default:
        throw Error(`checkIsOrderValid error ${data}`);
    }
  }
  function parserOrderState(orderState) {
    switch (orderState) {
      case 1:
        return {
          txt: 'pages.showOrderDetail.orderState.uncheck',
          style: 'orderStateUncheck'
        };
      case 2:
        return {
          txt: 'pages.showOrderDetail.orderState.check',
          style: 'orderStateChecked'
        };
      case 3:
        return {
          txt: 'pages.OrderDetail.orderState.NotTransfer',
          style: 'orderStateChecked'
        };
      case 4:
        return {
          txt: 'pages.showOrderDetail.orderState.official',
          style: 'orderStateOfficial'
        };
      case 5:
        return {
          txt: 'pages.OrderDetail.orderState.TransferError',
          style: 'orderStateOfficial'
        };
      case 6: {
        return {
          txt: 'pages.showOrderDetail.orderState.checking',
          style: 'orderStateChecking'
        };
      }
      case 0:
        return {
          txt: 'pages.showOrderDetail.orderState.invalid',
          style: 'orderStateExpired'
        };
      default:
        throw Error(`parserOrderState error ${orderState}`);
    }
  }
  if (!state.isInit) return null;
  return (
    <div className="Pages">
      <Header props={props} />
      <div className="TakeOrder col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0">
        <div className="Pages__section d-flex flex-column align-items-center pb-sm-4">
          <div className="Pages__title d-flex">
            <FormattedMessage
              id="pages.showOrderDetail.title"
              children={e => {
                const { langType } = globalState;
                if (
                  langType !== 'zh' &&
                  langType !== 'ja' &&
                  langType !== 'ko'
                ) {
                  const splitString = e.split(' ');
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                } else {
                  const splitString = e.split('');
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                }
              }}
            />
          </div>
        </div>

        {/* 訂單資訊 */}
        {
          state.orderList.map((e, index) =>
          (<>
            <div className="Pages__space w-100 mt-3 m-sm-0">
              <div className="border-bot p-3" onClick={() => {
                state.orderList[index].isOpen = !state.orderList[index].isOpen
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [{ key: 'orderList', val: state.orderList }]
                });
              }}>
                {/* 訂單代碼 */}
                <div className="d-flex justify-content-between align-items-center pt-2 pb-2">
                  <div>
                    <span className="mr-2">
                      <FormattedMessage id="pages.showOrderDetail.orderInfo.orderCode" />
                      :
                    </span>
                    <span className="mr-2 orderInfo txtColorLightGreen">
                      {e.orderCode || null}
                    </span>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div
                      className={cls(
                        'ml-2',
                        e.status
                          ? parserOrderState(e.status).style
                          : ''
                      )}
                    >
                      {e.status && (
                        <FormattedMessage
                          id={parserOrderState(e.status).txt}
                        />
                      )}
                    </div>
                    <div
                      className={cls(
                        'ml-2',
                        e.orderInfo
                          ? checkIsOrderValid(e.alive, e.status, e.createAt).style
                          : ''
                      )}
                    >
                      {e.status && (
                        <FormattedMessage
                          id={checkIsOrderValid(e.alive, e.status, e.createAt).txt}
                        />
                      )}
                    </div>
                    <div className='txtColorBrown ml-2'>{e.isOpen ? '▲' : '▼'}</div>
                  </div>
                </div>
                {/* 點餐時間 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    <FormattedMessage id="pages.showOrderDetail.orderInfo.time.orderTime" />
                    :
                  </span>
                  <span className="mr-2 txtColorBrown">
                    {e.createAt || null}
                  </span>
                </div>
              </div>
            </div>
            {e.isOpen === false ? null : (
              <>
                <div className="Pages__space w-100 mt-3 m-sm-0 border-bot" >
                  <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
                    <QRCode value={`${hostname}/staffCheckOrder?orderCode=${e.orderCode}&storeID=${e.storeID}&createAt=${moment(e.createAt).format('YYYY/MM/DD')}`} size={160} renderAs="svg" />
                  </div>
                  <div className="p-3">
                    <div className="d-flex flex-column flex-sm-row align-items-center p-0">
                      {/* 顧客資訊 */}
                      <div className="col col-sm-6 p-0 pt-2 pb-2">
                        <span className="mr-2">
                          {e.storeName || null}
                        </span>
                        <span className="mr-2">
                          {e.adultsCount || null}
                          <FormattedMessage id="pages.showOrderDetail.orderInfo.numberOfAdult" />
                        </span>
                        <span className="mr-2">
                          {e.childCount || null}
                          <FormattedMessage id="pages.showOrderDetail.orderInfo.numberOfChild" />
                        </span>                      
                      </div>
                      {/* 排隊號碼 */}
                      <div className="col col-sm-6 p-0 pt-2 pb-2">
                        <span className="mr-2">
                          <FormattedMessage id="pages.showOrderDetail.orderInfo.queueNumber" />
                          :
                        </span>
                        <span className="mr-2">
                          {e.queue_num || null}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-sm-row align-items-center p-0">
                      {/* 點餐時間 
                    <div className="col col-sm-6 p-0 pt-2 pb-2">
                      <span className="mr-2">
                        <FormattedMessage id="pages.showOrderDetail.orderInfo.time.orderTime" />
                        :
                      </span>
                      <span className="mr-2 txtColorBrown">
                        {e.createAt || null}
                      </span>
                    </div>*/}
                      {/* 用餐時間 */}
                      <div className="col col-sm-6 p-0 pt-2 pb-2">
                        <span className="mr-2">
                          <FormattedMessage id="pages.showOrderDetail.orderInfo.time.diningTime" />
                          :
                        </span>
                        <span className="mr-2 txtColorDarkBrown">
                          {e.diningTime || null}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-sm-row align-items-center p-0">
                      {/* 對單時間 */}
                      <div className="col col-sm-6 p-0 pt-2 pb-2">
                        <span className="mr-2">
                          <FormattedMessage id="pages.showOrderDetail.orderInfo.time.checkedTime" />
                          :
                        </span>
                        <span className="mr-2 txtColorDarkGreen">
                          {e.edtAt || null}
                        </span>
                      </div>
                      {/* 對單人員 */}
                      <div className="col col-sm-6 p-0 pt-2 pb-2">
                        <span className="mr-2">
                          <FormattedMessage id="pages.showOrderDetail.orderInfo.staff" />
                          :
                        </span>
                        <span className="mr-2 txtColorDarkGreen">
                          {e.groupName || null}
                        </span>
                        <span className="mr-2 txtColorDarkGreen">
                          {e.waiterWorkNum || null}
                        </span>
                        <span className="mr-2 txtColorDarkGreen">
                          {e.waiterName || null}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="Pages__section d-flex flex-column col p-0 pt-3">
                  {/* 內用 */}
                  <div className="Pages__section">
                    {e.dineIn.length > 0 ? (
                      e.dineIn.map((eachProduct, productIndex) => (
                        //<Tool_mealListShowOnly
                        //  key={productIndex}
                        //  deleteButton={false}
                        //  type="dineIn"
                        //  device={globalState.device}
                        //  data={eachProduct}
                        //  IsShowOrderDetail={true}
                        ///>
                        <div key={productIndex} className={
                          productIndex === e.dineIn.length - 1 ? "pt-1" : "border_under pt-1"
                        }>
                          <Tool_mealList
                            deleteButton={false}
                            modifyButton={false}
                            type="dineIn"
                            device={globalState.device}
                            data={eachProduct}
                            IsShowOrderDetail={true}
                          />
                        </div>
                      ))
                    ) : (
                      <div className="mt-3 text-center">
                        <FormattedMessage id="pages.showOrderDetail.dineInNotExist" />
                      </div>
                    )}
                  </div>
                  {/* 外帶 */}
                  <div className="Pages__section">
                    {(() => {
                      if (e.takeout.length <= 0) return null;
                      return (
                        <>
                          <div className="Pages__space">
                            <div className="Pages__specification__title Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
                              <FormattedMessage id="pages.showOrderDetail.takeOrder" />
                            </div>
                          </div>
                          {e.takeout.map((eachProduct, productIndex) => (
                            //<Tool_mealListShowOnly
                            //  key={productIndex}
                            //  deleteButton={false}
                            //  type="takeout"
                            //  device={globalState.device}
                            //  data={eachProduct}
                            //  IsShowOrderDetail={true}
                            ///>
                            <div key={productIndex} className={
                              productIndex === e.takeout.length - 1 ? "pt-1" : "border_under pt-1"
                            }>
                              <Tool_mealList
                                deleteButton={false}
                                modifyButton={false}
                                type="takeout"
                                device={globalState.device}
                                data={eachProduct}
                                IsShowOrderDetail={true}
                              />
                            </div>
                          ))}
                        </>
                      );
                    })()}
                  </div>
                </div>
                {/* 附加選項 */}
               
                {e.extraDataList.length > 0 ? (
                  <>
                    <div className="Pages__space w-100">
                      <div className="Pages__specification__title Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
                        <FormattedMessage id="pages.staffCheckOrder.orderInfo.otherNeed" />
                      </div>
                    </div>
                    <Tool_showExtraDataList extraData={e.extraDataList} />
                  </>
                ) : (
                  ""
                )}
                {/* 價格 */}
                <div className="Pages__section d-flex flex-column col p-0">
                  <div className="Pages__section Pages__space mt-2 mt-sm-4 mb-2 mb-sm-4">
                    <div className="Pages__space__item">
                      {/* 合計 */}
                      <div className="d-flex pr-3 pl-3">
                        <div className="col-4 col-sm-7"></div>
                        <div
                          className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
                          style={{ borderBottom: '1px solid rgba(0,0,0,.1)' }}
                        >
                          <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                            <FormattedMessage id="pages.showOrderDetail.sum.price" />
                          </div>
                          <div className="d-flex justify-content-end align-items-center col-6 p-0 orderInfo">
                            $
                            {formatNumber(
                              totalPriceList(e).dineInSpecPrice +
                              totalPriceList(e).dineInTotalPrice +
                              totalPriceList(e).takeoutInSpecPrice +
                              totalPriceList(e).takeoutInTotalPrice,
                              2
                            )}
                          </div>
                        </div>
                      </div>
                      {/* 服務費 */}
                      <div className="d-flex pr-3 pl-3">
                        <div className="col-4 col-sm-7"></div>
                        <div
                          className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
                          style={{ borderBottom: '1px solid rgba(0,0,0,.1)' }}
                        >
                          <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                            <FormattedMessage id="pages.showOrderDetail.sum.tips" />
                            (10%)
                          </div>
                          <div
                            className="d-flex justify-content-end align-items-center col-6 p-0"
                            style={{ fontSize: '20px' }}
                          >
                            $
                            {formatNumber(
                              (totalPriceList(e).dineInSpecPrice +
                                totalPriceList(e).dineInTotalPrice) *
                              0.1,
                              2
                            )}
                          </div>
                        </div>
                      </div>
                      {/* 總計 */}
                      <div className="d-flex pr-3 pl-3">
                        <div className="col-4 col-sm-7"></div>
                        <div className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3">
                          <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                            <FormattedMessage id="pages.showOrderDetail.sum.total" />
                          </div>
                          <div
                            className="d-flex justify-content-end align-items-center col-6 p-0 txtColorBrown"
                            style={{ fontSize: '20px' }}
                          >
                            $
                            {formatNumber(
                              (totalPriceList(e).dineInSpecPrice +
                                totalPriceList(e).dineInTotalPrice) *
                              1.1 +
                              totalPriceList(e).takeoutInSpecPrice +
                              totalPriceList(e).takeoutInTotalPrice,
                              2
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>)}
          </>
          )
          )
        }
        <div className="Pages__section">
          <div className="d-flex justify-content-center align-items-center p-3 txtColorRed text-justify">
            <FormattedMessage id="pages.showOrderDetail.orderNotice" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ShowOrderDetail;
